import { optionSchema } from "@/common/schemas/option.schema";
import z from "zod";

export const maintenanceSpecificationSchema = z.object({
  id: z.string().optional(),
  directive_klass: z.string().optional(),
  equipment_category_specifications_attributes: z
    .array(optionSchema, { message: 'Campo obrigatório' })
    .min(1, { message: 'Campo obrigatório' }),
  equipment_manufacturer_specifications_attributes: z
    .array(optionSchema, { message: 'Campo obrigatório' })
    .min(1, { message: 'Campo obrigatório' }),
  system_specifications_attributes: z
    .array(optionSchema, { message: 'Campo obrigatório' })
    .min(1, { message: 'Campo obrigatório' }),
});

export type MaintenanceSpecificationValidationSchema = z.infer<typeof maintenanceSpecificationSchema>;
